import React, { useState } from 'react'
import propTypes from 'prop-types'
import { Button, Grid } from '@material-ui/core'

import { DialogView } from '../../common/Dialog'
import DropDownZone from '../../common/DropDownZone'
import FileContent from '../../common/FileContent'
import AlertComponent from '../../common/AlertComponent'

export const IMPORT_DIALOG_TITLE = 'Import substitute materials'
/**
 * Only .xlsx. The server reads the sheet with a library that handles that format and no other, so
 * offering .xls or .csv in the picker would let the user choose a file the import must then refuse.
 */
export const ACCEPTED_EXTENSIONS = '.xlsx'

export const IMPORT_HINT =
	'The file must contain one sheet with four columns: discontinued material code, its description, substitute material code and its description. ' +
	'Rows missing either code are skipped. A discontinued material already in the catalog is updated, not duplicated.'

/**
 * Import dialog for the substitute materials catalog.
 *
 * The extension filter on the picker is a capture aid, not the validation: whether the file's
 * structure is the expected one is decided by the server, which is the side that processes it. The
 * client does not parse the sheet to second-guess that.
 */
const ImportSubstituteMaterialsDialog = (props) => {
	const { open, onClose, onImport, isImporting } = props
	const [selectedFiles, setSelectedFiles] = useState([])

	const canConfirm = selectedFiles.length > 0 && !isImporting

	const onFilesReceived = (files) => {
		if (files && files.length > 0) {
			setSelectedFiles([{ id: files[0].name, attachment: files[0] }])
		}
	}

	const onRemoveFile = () => setSelectedFiles([])

	const onConfirm = () => {
		if (onImport && selectedFiles.length > 0) {
			onImport(selectedFiles[0].attachment)
		}
	}

	return (
		<DialogView
			open={open}
			onClose={onClose}
			disabled={isImporting}
			isSaving={isImporting}
			header={IMPORT_DIALOG_TITLE}
			maxWidth='sm'
			actions={
				<>
					<Button onClick={onClose} disabled={isImporting}>
						Cancel
					</Button>
					<Button onClick={onConfirm} variant='outlined' color='primary' disabled={!canConfirm}>
						Import
					</Button>
				</>
			}
		>
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<AlertComponent title='Import substitute materials' severityType='info' message={IMPORT_HINT} />
				</Grid>
				<Grid item xs={12}>
					<DropDownZone
						datacy='drop-zone-substitute-materials'
						accept={ACCEPTED_EXTENSIONS}
						multiple={false}
						message={'Click here to select a file'}
						onFilesReceived={onFilesReceived}
					/>
				</Grid>
				<Grid item xs={12}>
					{selectedFiles.length > 0 && <FileContent files={selectedFiles} onRemoveFile={onRemoveFile} />}
				</Grid>
			</Grid>
		</DialogView>
	)
}

ImportSubstituteMaterialsDialog.propTypes = {
	open: propTypes.bool.isRequired,
	onClose: propTypes.func.isRequired,
	/**Receives the selected file */
	onImport: propTypes.func.isRequired,
	/**Whether an import is in flight; also what keeps confirm from firing twice */
	isImporting: propTypes.bool
}

ImportSubstituteMaterialsDialog.defaultProps = {
	open: false,
	isImporting: false,
	onClose: () => console.warn('Callback [onClose] no defined'),
	onImport: () => console.warn('Callback [onImport] no defined')
}

export default ImportSubstituteMaterialsDialog
